import React, { createContext, useContext, ReactNode } from "react"
import { NavigateFunction } from "react-router-dom"
import Config from "src/config/Config"
import ApiHandler from "src/api/ApiHandler"
import ErrorHandler from "src/components/errors/ErrorHandler"
import Loader from "src/components/general/Loading"
import LoginHelper from "src/components/login/LoginHelper"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import FeatureProvider from "src/features/FeatureProvider"
import navigationService from "src/navigation/NavigationService"
import PathRouter from "src/navigation/PathRouter"
import type { AnalysisBuilderChain } from "src/components/areas/areaAnalysisDescription/analysis_builders/AnalysisBuilderChain"

export interface AppDependencies {
    config: Config
    apiHandler: ApiHandler
    errorHandler: ErrorHandler
    loader: Loader
    loginHelper: LoginHelper
    stateHandler: EventAdaptingStateHandler
    featureProvider: FeatureProvider
    pathRouter: PathRouter
    areaAnalysisBuilderChain: AnalysisBuilderChain
}

interface AppContextType {
    dependencies: AppDependencies
}

const AppContext = createContext<AppContextType | undefined>(undefined)

interface AppProviderProps {
    dependencies: AppDependencies
    children: ReactNode
}

export function AppProvider({ dependencies, children }: AppProviderProps) {
    return (
        <AppContext.Provider value={{ dependencies }}>
            {children}
        </AppContext.Provider>
    )
}

export function useAppDependencies(): AppDependencies {
    const context = useContext(AppContext)
    if (!context) {
        throw new Error("useAppDependencies must be used within AppProvider")
    }
    return context.dependencies
}

